<template>
  <div style="border: 1px solid #fe433b; border-radius: 8px">
    <v-layout row wrap class="ma-0 pl-3">
      <v-flex xs9 class="mt-2">
        <div
          v-if="value.error_status || value.have_error"
          style="color: red; font-weight: bold; font-size: 17px"
        >
          ไม่สำเร็จ
          <span
            style="cursor: pointer; text-decoration: underline"
            @click="$emit('errorView', value)"
            >ตรวจสอบ error</span
          >
        </div>
        <div style="font-weight: bold; font-size: 17px; color: black">
          <span v-if="value.postaction == 'deleted'" class="red--text">(โพสต์ถูกลบแล้ว)&nbsp;</span>
          {{ value.name }}
        </div>
        <div>
          {{ value.messages }}
        </div>
        <div class="caption">
          {{ value.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
        </div>
        <div v-if="value.scheduletime">
          ตั้งเวลาโพสต์&nbsp;{{ value.scheduletime | DateFormat('DD/MM/YYYY HH:mm') }}
        </div>
        <div>โพสต์โดย {{ value.admin }}</div>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn
          v-if="
            !published() ||
            (published() &&
              value.postaction != null &&
              !['', 'deleted'].includes(value.postaction) &&
              !value.publish)
          "
          small
          color="primary"
          outline
          icon
          @click="$emit('edit', value)"
          ><v-icon small>edit</v-icon></v-btn
        >
        <v-btn
          v-if="
            value.postaction != null && !['', 'deleted'].includes(value.postaction) && value.publish
          "
          small
          color="primary"
          outline
          icon
          @click="$emit('delete', value)"
          ><v-icon small>delete</v-icon></v-btn
        >
        <v-btn small color="primary" outline icon @click="$emit('copy', value)">
          <em class="fas fa-copy" />
        </v-btn>
        <v-btn
          v-if="!value.publish"
          small
          color="primary"
          outline
          icon
          @click="$emit('delete', value)"
          ><v-icon small>delete</v-icon></v-btn
        >
        <v-btn v-else small color="primary" outline icon @click="$emit('view', value)">
          <em class="fas fa-eye" />
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  inject: ['published'],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookPostManager/FacebookPostItem.vue